<app-modal
  [title]="'Terminal session transactions'| trans:'terminal-session-transactions-modal/header/title'"
  maxWidth="1000px"
>
  <ng-template>
    @if (isLoading()) {
      <div class="d-flex justify-content-center full-height align-items-center">
        <app-loader size="lg" />
      </div>
    } @else {
      @if (transactions.length > 0) {
        <table class="base full-width table-layout-fixed">
          <thead>
          <tr>
            <th width="35%">
              {{ 'Zeit'| trans:'terminal-session-transactions-modal/table/openingDate.Label' }}
            </th>
            <th width="35%">
              {{ 'Inhalt'| trans:'terminal-session-transactions-modal/table/content.Label' }}
            </th>
            <th width="15%" class="text-right">
              {{ 'Gesamt'| trans:'terminal-session-transactions-modal/table/totalAmount.Label' }}
            </th>
            <th width="15%">
              {{ 'Währung'| trans:'terminal-session-transactions-modal/currency.Text' }}
            </th>
          </tr>
          </thead>
          <tbody>
            @for (t of transactions; track t.id;) {
              <tr
                class="selectable-tr cursor-pointer"
                [class.selected]="selectedTransactions.has(t.id)"
                (click)="selectedTransactions.has(t.id) ? selectedTransactions.delete(t.id) : selectedTransactions.set(t.id, t)"
              >
                <td>
                  <div class="white-space-nowrap overflow-hidden text-overflow-ellipsis">
                    {{ t.openingDate | localeDatetimeFormat }}
                  </div>
                </td>
                <td>
                  <div class="white-space-nowrap overflow-hidden text-overflow-ellipsis">
                    {{ t.content }}
                  </div>
                </td>
                <td>
                  <div class="white-space-nowrap overflow-hidden text-overflow-ellipsis text-right">
                    {{ t.totalAmount | numberToCurrency }}
                  </div>
                </td>
                <td>
                  <div class="white-space-nowrap overflow-hidden text-overflow-ellipsis">
                    {{ t.currency }}
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      } @else {
        <p>{{ 'No session transactions found.' | trans:'terminal-session-transactions-modal/noSessionTransactionsFound.Text' }}</p>
      }
    }
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-flex-end">
      <button
        class="button button--md button--primary-ghost text-uppercase"
        (click)="close()"
      >
        {{ 'Close'| trans:'terminal-session-transactions-modal/close.Button' }}
      </button>

      <button
        #btn
        class="button button--md button--primary text-uppercase"
        [disabled]="selectedTransactions.size === 0 || isLoading()"
        (click)="printReceipts()"
      >
        {{ 'Print'| trans:'terminal-session-transactions-modal/print.Button' }}
      </button>
    </div>
  </ng-container>
</app-modal>
